import { calculateBillingLineItemTotalInCents } from '@/shared'

export type TotalsLine = { kWh?: number; tariffPerKWh?: number }

export function calcCreditNoteTotals(lines: TotalsLine[], vatPercentage: number) {
  const subTotalCents = lines.reduce(
    (total, { kWh, tariffPerKWh }) => total + calculateBillingLineItemTotalInCents({ quantity: kWh ?? 0, rateInRands: (tariffPerKWh ?? 0) }),
    0
  )
  const vatCents = Math.round(subTotalCents * (vatPercentage / 100))
  return {
    subTotalCents,
    vatCents,
    totalCents: subTotalCents + vatCents
  }
}
